import React from "react"

export default function FaceBookIcon() {
	return (
		<svg
			width="31"
			height="30"
			viewBox="0 0 31 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18.8757 8.32002H20.7557V5.14003C19.8455 5.04538 18.9309 4.99865 18.0157 5.00003C15.2957 5.00003 13.4357 6.66003 13.4357 9.70002V12.32H10.3657V15.88H13.4357V25H17.1157V15.88H20.1757L20.6357 12.32H17.1157V10.05C17.1157 9.00002 17.3957 8.32002 18.8757 8.32002Z"
				fill="white" 
			/>
		</svg>
	)
}
